import React from 'react';
import { DestinationPointProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDestinationLocation, setDestinationLocation } from '@src/features/order/pages/upsert-order-page/redux';
import { DestinationMarker, getLocationFromMap } from '@src/core/controllers';

const DestinationPoint: React.FC<DestinationPointProps> = ({ draggable = true }) => {
  const dispatch = useDispatch();
  const location = useSelector(selectDestinationLocation);

  const onDragEnd = async (e: google.maps.MapMouseEvent) => {
    const location = await getLocationFromMap(e);
    
    if (!location) return;
  
    dispatch(setDestinationLocation(location));
  };

  const lat = Number(location?.latitude);
  const lng = Number(location?.longitude);

  if (isNaN(lat) || isNaN(lng)) return null;

  return (
    <React.Fragment>
      <DestinationMarker.confirmed draggable={draggable} zIndex={2000} position={{ lat, lng }} onDragEnd={onDragEnd} />
    </React.Fragment>
  );
};

export default DestinationPoint;
